// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__ATNL6","title":"AfterFrontImage_title__2O7eD"};